import store from "store2";

import cache from "./store.cache";
import state from "./store.state";

cache(store);
state(store);

export default store;
